import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';

import { useAppSelector } from '@app/core/hooks';
import { cpmsBoTariffSlice } from '@app/core/service/cpms-bo-tariff.slice';
import { useCpmsBoGetTariffQuery } from '@service/cpms-bo-tariff.service';

export interface TariffFilterStateControllerProps {
  value: TariffModel['id'];
  onRemove: FilteredItemProps['onRemove'];
}

export const TariffFilterStateController = ({
  value,
  onRemove,
}: TariffFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const tariff = useAppSelector((state) =>
    cpmsBoTariffSlice.selectors.selectById(state, value),
  );

  const { data: tariffApiData } = useCpmsBoGetTariffQuery(value, {
    skip: !!tariff,
  });

  const tariffName = tariff?.name ?? tariffApiData?.name ?? '';

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="currency-euro-circle"
      label={tariffName}
      onRemove={onRemove}
    />
  );
};
